import {
  BpkBox,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';

import STYLES from './Separator.module.scss';

// The `hr` stays native: Backpack layout props cannot express a 1px
// `line-day` border, and BpkBox does not accept a `className` (so
// `<BpkBox as="hr">` cannot carry the border rule). Only that rule remains
// in SCSS.
const Separator = () => (
  <BpkBox marginTop={BpkSpacing.LG} marginBottom={BpkSpacing.LG}>
    <hr className={STYLES.Separator} aria-hidden="true" />
  </BpkBox>
);

export default Separator;
